<template>
  <Layout v-loading="isLoading">
    <template #top>
      <Head :searchConfig="tableData.searchConfig" @searchData="searchData" />
    </template>
    <template>
      <Body
        :headConfig="tableData.headConfig"
        :tableData="data.content"
        @unbind="unbind"
      />
    </template>
    <template #bottom>
      <Foot :total="data.total" @get-data="getPage" />
    </template>
  </Layout>
</template>

<script>
import { email } from "@/utils/regexp.js";
import getBindUserPage from "@/api/getBindUserPage.js";
import unbindUser from "@/api/unbindUser.js";
import Layout from "@/components/Layout";
import Head from "@/components/Table/Head";
import Body from "@/components/Table/Body";
import Foot from "@/components/Table/Foot";
import requstData from "@/mixins/requstData.js";
import { mapState } from "vuex";
export default {
  mixins: [requstData({ content: [], total: 0 }, false)],
  components: {
    Layout,
    Head,
    Body,
    Foot,
  },
  data() {
    return {
      tableData: {
        headConfig: {
          select: false,
          key: "id",
          list: [
            { label: "用户", prop: "userName", width: "250" },
            { label: "专页名称", prop: "pageName" },
            { label: "专页ID", prop: "pageId" },
            { label: "授权管理员", prop: "authorizationAdmin" },
            { label: "授权日期", prop: "authorizationDate", width: "180" },
            {
              label: "操作",
              width: "200",
              operation: [
                {
                  type: 1,
                  label: "解除绑定",
                  style: "danger",
                  listeners: "unbind",
                  confirm: "确定解除绑定？",
                },
              ],
            },
          ],
        },
        searchConfig: {
          list: [
            {
              type: "input",
              model: "userName",
              span: 4,
              placeholder: "请输入用户名或专页名称",
            },
            {
              type: "button",
              span: 5,
              operation: [
                {
                  type: 1,
                  label: "查询",
                  style: "primary",
                  listeners: "searchData",
                },
              ],
            },
          ],
        },
      },
    };
  },
  mounted() {
    this.search = {
      userName: this.user.userName,
    };
    this.getData();
  },
  computed: {
    ...mapState("loginUser", ["user"]),
  },
  methods: {
    async requst(params) {
      const { pageNumber, pageSize, userName } = params;
      let newParams;
      if (email.test(userName)) {
        newParams = params;
      } else {
        delete params.userName;
        newParams = { ...{ pageName: userName }, ...params };
      }
      return await getBindUserPage(newParams);
    },
    async unbind(data) {
      this.isLoading = true;
      let res = await unbindUser({ id: data.id });
      this.isLoading = false;
      if (res === "ok") {
        this.$message({
          showClose: true,
          type: "success",
          message: "解除成功",
        });
        this.getData();
      }
    },
  },
};
</script>

<style></style>
